import { UIHeading2, UIText2 } from '@cian/ui-kit';
import { Button } from '@cian/ui-kit/button';
import * as React from 'react';

import { trackSearchOffersButtonClick, trackSignInButtonClick } from './tracking';
import { EDeviceType } from '../../types/device';
import { IFiltersState } from '../../types/filters';
import { TUser } from '../../types/user';
import { getSearchUrl } from '../../utils/filters';

import * as styles from './ResultsEmpty.css';

export interface IResultsEmptyProps {
  user: TUser;
  filters: IFiltersState;
  deviceType: EDeviceType;
}

export const ResultsEmptyNewbuilding: React.FC<IResultsEmptyProps> = ({
  user: { isAuthenticated },
  filters,
  deviceType,
}) => {
  const handleButtonClick = React.useCallback(() => {
    if (isAuthenticated) {
      window.location.assign(getSearchUrl(filters));
      trackSearchOffersButtonClick();
    } else {
      if (window.hasOwnProperty('waitForLoginPopup')) {
        window.waitForLoginPopup();
      }
      trackSignInButtonClick();
    }
  }, [isAuthenticated]);

  return (
    <div className={styles['container']}>
      <div className={styles['wrapper']}>
        <div className={styles['content']}>
          <div className={styles['empty-newbuilding-background']} />
          <div className={styles['title']}>
            <UIHeading2>Сохраняйте интересные жилые комплексы</UIHeading2>
          </div>
          <div className={styles['description']}>
            <UIText2>Сообщим вам про новые предложения и скидки, если они будут</UIText2>
          </div>
          <Button
            size={deviceType === EDeviceType.Desktop ? 'XS' : 'M'}
            theme="fill_primary"
            onClick={handleButtonClick}
          >
            {isAuthenticated ? 'Искать объявления' : 'Войти'}
          </Button>
        </div>
      </div>
    </div>
  );
};
